<template>
  <DynamicModal
    :showModal="showModalProp"
    :persistent="false"
    @clickOutside="closeModal"
    title="Missing Data"
    maxWidth="800px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="taskCreationForm">
        <v-row class="mt-2">
          <v-col cols="12">
            <h3>
              The following fields are missing:
            </h3>
            <ul class="mt-2">
              <li v-for="missingField of missingFields" :key="missingField">
                {{ missingField }}
              </li>
            </ul>
            <br>
            <h3>
              Do you want to create a task to complete the missing information later?
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <UsersDropDownList
              :userId="userIdValue"
              :isRequired="true"
              :onlyActiveUsers="true"
              label="Responsible"
              @userIdChange="(newValue) => {this.userIdValue = newValue}"
            ></UsersDropDownList>
          </v-col>
          <v-col cols="12" md="6">
            <SimpleDatePicker
              label="Due Date"
              :minDateEnable="true"
              :value="dueDateValue"
              :isRequired="true"
              @selected-date-change="(newValue) => this.dueDateValue = newValue"
            ></SimpleDatePicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="taskNotesValue"
              label="Notes"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-4">
          <v-btn
            block
            depressed
            color="primary"
            @click="createTask"
          >
            Create Task
          </v-btn>
        </div>
        <div class="col-4">
          <v-btn
            block
            depressed
            color="primary"
            @click="doNotCreateTask"
          >
            Don't Create Task
          </v-btn>
        </div>
        <div class="col-4">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import { UsersDropDownList } from '@/components/users'
import { SimpleDatePicker } from '@/components/shared/datePickers'
import { getCurrentUser } from '@/lib/authentication'

export default {
  components: {
    DynamicModal,
    UsersDropDownList,
    SimpleDatePicker
  },
  props: [
    'userId',
    'dueDate',
    'taskNotes'
  ],
  data () {
    return {
      showModalProp: false,
      user: null,
      missingFields: null
    }
  },
  computed: {
    userIdValue: {
      get () {
        return this.userId
      },
      set (newValue) {
        this.$emit('userIdChange', newValue)
      }
    },
    dueDateValue: {
      get () {
        return this.dueDate
      },
      set (newValue) {
        this.$emit('dueDateChange', newValue)
      }
    },
    taskNotesValue: {
      get () {
        return this.taskNotes
      },
      set (newValue) {
        this.$emit('taskNotesChange', newValue)
      }
    }
  },
  methods: {
    getCurrentUser,
    showModal (missingFields) {
      this.showModalProp = true
      this.missingFields = missingFields
    },
    closeModal () {
      this.showModalProp = false
      this.dueDateValue = null
      this.taskNotesValue = null
      this.$emit('closeModal')
    },
    createTask () {
      if (this.$refs.taskCreationForm.validate()) {
        this.$emit('createTask')
        this.closeModal()
      }
    },
    doNotCreateTask () {
      this.$emit('doNotCreateTask')
      this.closeModal()
    }
  },
  mounted () {
    this.userIdValue = getCurrentUser().id
  }
}
</script>
